module.exports = __webpack_public_path__ + "static/media/RP-66.8becb642.pdf";